import { LodashExtractor } from '@ddt-web/data-service';
import { DateUtil } from '@ddt-web/generic-utils';

import { FactMappingInterface } from '../../../models/fact-mapping.interface';
import { FactExtractor } from '../fact-extractor';

export const CAP_FACTS: { [factName: string]: FactMappingInterface } = {
	medianETFAllocation: {
		extractor: new FactExtractor([new LodashExtractor('compareAgainstPeers.etfs.PERCENTILE_50')], etfs => {
			return etfs;
		})
	},
	capAnalysisDate: {
		extractor: new FactExtractor([new LodashExtractor('compareAgainstPeers.asOfDate')], asOfDate => {
			return Number(DateUtil.convertToUTCBfmDate(asOfDate));
		})
	},

	capFeesUpperBenchmark: {
		extractor: new FactExtractor([new LodashExtractor('compareAgainstPeers.fees.PERCENTILE_50')], capFees => {
			return capFees + 0.05;
		})
	},
	capFeesLowerBenchmark: {
		extractor: new FactExtractor([new LodashExtractor('compareAgainstPeers.fees.PERCENTILE_50')], capFees => {
			return capFees - 0.05;
		})
	},

	capEtfsUpperBenchmark: {
		extractor: new FactExtractor([new LodashExtractor('compareAgainstPeers.etfs.PERCENTILE_50')], capEtfs => {
			return capEtfs + 5;
		})
	},

	capEtfsLowerBenchmark: {
		extractor: new FactExtractor([new LodashExtractor('compareAgainstPeers.etfs.PERCENTILE_50')], capEtfs => {
			return capEtfs - 5;
		})
	}
};
